import React, { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { A11y, Pagination, Zoom, Scrollbar } from "swiper/modules";
import "swiper/css/bundle";
import "./styles.css";
import { getImageBiggerSide } from "../../../../utils";
import { IMAGE_SIDES } from "../../../../constants/common";
import { useIsMobile } from "../../../../hooks/useIsMobile";

export const Slider = ({ images }) => {
    const [slide, setSlide] = useState(0);
    const [biggerSide, setBiggerSide] = useState("width");
    const [showSwipeHint, setShowSwipeHint] = useState(false);
    const swiperRef = useRef<any>(null);
    const isMobile = useIsMobile();

    // Если массив изображений пустой – используется запасной URL
    const imagesArray =
        images && images.length > 0
            ? images
            : ["https://husamhelper.ru/storage/images/phpi34fvnh4atr96ZehtUx.png"];
    const imageUrl = imagesArray[slide];

    const handleChangeSlide = (index) => {
        setSlide(index);
    };

    useEffect(() => {
        getImageBiggerSide(imageUrl).then((side) => {
            setBiggerSide(side);
        });
    }, [imageUrl]);

    useEffect(() => {
        if (!isMobile) {
            setShowSwipeHint(false);
            return;
        }

        setShowSwipeHint(true);
        const timeoutId = window.setTimeout(() => {
            setShowSwipeHint(false);
        }, 3500);

        return () => window.clearTimeout(timeoutId);
    }, [isMobile, imagesArray.length]);

    return (
        <div className="slider_container">
            <div
                className="slider_background"
                style={{ backgroundImage: `url(${imageUrl})` }}
            />
            <div className="slider_overlay" />
            <div className="slider_blur">
                <Swiper
                    modules={[Pagination, Scrollbar, A11y, Zoom]}
                    spaceBetween={50}
                    slidesPerView={1}
                    loop={imagesArray.length > 1}
                    pagination={{
                        clickable: true,
                        el: ".slider_pagination",
                    }}
                    scrollbar={{ draggable: true }}
                    style={{
                        "--swiper-pagination-color": "#FFC800",
                        "--swiper-navigation-color": "#FFC800",
                    }}
                    zoom={{ maxRatio: 3, minRatio: 1 }}
                    onSwiper={(swiper) => {
                        swiperRef.current = swiper;
                    }}
                    onTouchStart={() => setShowSwipeHint(false)}
                    onSlideChange={(swiper) => handleChangeSlide(swiper.realIndex)}
                >
                    {imagesArray.map((image, index) => (
                        <SwiperSlide key={index}>
                            <div className="swiper-zoom-container">
                                <img
                                    className="slider_image"
                                    src={image}
                                    alt={`Слайд ${index + 1}`}
                                    width={biggerSide === IMAGE_SIDES.width ? "100%" : "auto"}
                                    height={biggerSide === IMAGE_SIDES.height ? "100%" : "auto"}
                                />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
                {imagesArray.length > 1 ? (
                    <>
                        <button
                            type="button"
                            className="slider_nav slider_nav-prev"
                            aria-label="Предыдущий слайд"
                            onClick={() => swiperRef.current?.slidePrev()}
                        >
                            <ChevronLeft size={20} aria-hidden="true" />
                        </button>
                        <button
                            type="button"
                            className="slider_nav slider_nav-next"
                            aria-label="Следующий слайд"
                            onClick={() => swiperRef.current?.slideNext()}
                        >
                            <ChevronRight size={20} aria-hidden="true" />
                        </button>
                    </>
                ) : null}
                {showSwipeHint && (
                    <div className="slider_swipe-hint" aria-hidden="true">
                        <span className="slider_swipe-hint-icon">↔</span>
                        Листайте пальцем, чтобы посмотреть фото
                    </div>
                )}
            </div>
            <div className="slider_pagination" />
        </div>
    );
};
